import CustomerSortMenu from './CustomerSortMenu'

export default CustomerSortMenu
